module.exports = __webpack_public_path__ + "static/media/bs.5da55fe4.svg";